import * as React from 'react';

import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import TargetByStudentIdContainer from './TargetByStudentIdContainer';
import TargetByStudentIdPanel from './TargetByStudentIdPanel';
import { StudentIdListRecipient, ComposerOrganization } from 'types/typescript/messagingTypes';
import { TargetByStudentIdPages } from './SelectRecipientPanel';

type Props = {
  onContinue: () => void;
  onPageChange: (page: TargetByStudentIdPages) => void;
  organizations?: Partial<ComposerOrganization>[];
  studentIdListRecipientInSelection?: StudentIdListRecipient;
};

export default class TargetByStudentId extends React.Component<Props> {
  render() {
    if (!this.props.organizations) {
      return <CenteredLoadingIndicator />;
    }

    // Need to tell typescript what filter is achieving, in newer ts versions this shouldn't be needed
    const organizationUuids = this.props.organizations
      .map((organization) => organization.uuid)
      .filter(Boolean) as Array<string>;
    return (
      <TargetByStudentIdContainer organizationUuids={organizationUuids}>
        {(props: any) => (
          <TargetByStudentIdPanel
            {...props}
            onContinue={this.props.onContinue}
            onPageChange={this.props.onPageChange}
            studentIdListRecipientInSelection={this.props.studentIdListRecipientInSelection}
          />
        )}
      </TargetByStudentIdContainer>
    );
  }
}
